import { Component, OnInit, Self, ViewEncapsulation } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, NgControl, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { YesNoComponent } from '../yes-no/yes-no.component';
import { ControlBaseComponent } from '../control-base/control-base.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { StateService } from '../../../services/state.service';

@Component({
    selector: 'minster-checkbox',
    standalone: true,
    imports: [MatFormFieldModule, FormsModule, MatInputModule, YesNoComponent, MatIconModule, MatTooltipModule],
    templateUrl: './minster-checkbox.component.html',
    styleUrl: './minster-checkbox.component.css',
    encapsulation: ViewEncapsulation.None
})
export class MinsterCheckboxComponent extends ControlBaseComponent<boolean> implements OnInit {

    _control: NgControl

    constructor(@Self() public controlDir: NgControl, stateService: StateService) {
        super(controlDir, stateService);
        this._control = controlDir;
    }

    ngOnInit(): void {
        this.setup();

        const control = this.controlDir.control;
        let myValidators = [];

        if (this._required && !this._disabled) {
            myValidators.push(Validators.required);
        }

        if (control) {
            let validators = control.validator ? [control.validator, ...myValidators] : myValidators;

            control.setValidators(validators)
            control.updateValueAndValidity();
        }
    }

    onChange(val: any): void {
        this._value = val;
        this._propagateChange(val);
        this._propagateTouched();
    }
}
